<script setup lang="ts">
defineProps<{
  blog: any
  lazy: boolean
}>()
</script>

<template>
  <article
    v-if="blog"
    class="blog-tile"
  >
    <div class="blog-tile__wrapper">
      <div class="blog-tile__content">
        <h3
          class="blog-tile__heading"
        >
          <AppLink
            class="blog-tile__link"
            :to="`/${blog?.PageUrl?.url}`"
          >
            {{ blog?.PageTitle }}
          </AppLink>
        </h3>

        <p
          class="blog-tile__description"
        >
          {{ blog?.Description }}
        </p>

        <div
          aria-hidden="true"
          class="blog-tile__button"
        >
          <span>{{ $t('Read more') }}</span>
        </div>

        <!-- <div class="blog-tile__info">
          <img
            v-if="blog?.Author?.Image?.url"
            :src="useXcdnImage(blog.Author?.Image?.url, 'f=rs:fit:40')"
            :alt="blog.Author.Image.alternativeText || blog.Author.Name"
            :width="blog.Author.Image.width"
            :height="blog.Author.Image.height"
            :loading="lazy ? 'lazy' : 'eager'"
            :fetchpriority="lazy ? 'low' : 'high'"
            :decoding="lazy ? 'async' : 'sync'"
            class="blog-tile__author-image"
          >
          <span
            v-if="blog?.Author?.Name"
            class="blog-tile__author"
          >
            {{ blog?.Author?.Name }} in {{ blog?.ParentPage?.PageTitle }}
          </span>

          <span
            v-if="blog?.PublicationDate"
            class="blog-tile__date"
          >
            {{ $td(new Date(blog.PublicationDate), 'long') }}
          </span>

          <span
            v-if="blog?.ReadingTime"
            class="blog-tile__reading-time"
          >
            -
            <IconClock class="icon icon--clock" />
            {{ blog?.ReadingTime }} {{ $t('minutes') }}
          </span>
        </div> -->
      </div>

      <div class="blog-tile__visual">
        <picture v-if="blog?.Image?.url">
          <source
            :srcset="useXcdnImage(blog.Image.url, 'f=rs:fit:436')"
            media="(min-width: 1024px)"
          >
          <source
            :srcset="useXcdnImage(blog.Image.url, 'f=rs:fit:436')"
            media="(min-width: 768px)"
          >
          <source
            :srcset="useXcdnImage(blog.Image.url, 'f=rs:fit:436')"
          >
          <img
            v-if="blog?.Image?.url"
            class="blog-tile__image"
            :src="useXcdnImage(blog.Image.url, 'f=rs:fit:436')"
            :alt="blog.Image.alternativeText || blog.PageTitle"
            :width="blog.Image.width"
            :height="blog.Image.height"
            :loading="lazy ? 'lazy' : 'eager'"
            :fetchpriority="lazy ? 'low' : 'high'"
            :decoding="lazy ? 'async' : 'sync'"
          >
        </picture>
      </div>
    </div>

    <!-- <pre>blog: {{ blog }}</pre> -->
  </article>
</template>

<style>
@import url("~layers/app/components/Blog/Tile.css");
</style>
